export const bump_url: string = "bump";